import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, of, Subscription, switchMap, timer } from 'rxjs';
import { Constants } from '../models/constants';
import { DateTimeService } from './date-time/date-time.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class DeploymentCheckService {
  private deploymentApiUrl = `${Constants.APP_BASE_API_URL}/getActiveDowntimeWindow?requestType=DOWNTIME_PAGE_STATUS`;
  private message = '';
  private messageSource = new BehaviorSubject<any>(null);
  currentMessage = this.messageSource.asObservable();
  private pollingSubscription: Subscription;
  constructor(private http: HttpClient, private dateTimeService: DateTimeService, private router: Router) { }

  startPolling(): void {
    this.pollingSubscription = timer(1000, Constants.deploymentWindowCheckTimeInSeconds) // Poll every 1 minutes
      .pipe(
        switchMap(() => this.getActiveDowntimeWindow().pipe(
          catchError((error) => {
            return of(null);
          })
        )), // Get active downtime window API
      ).subscribe({
        next: (res: any) => {
          if (res?.downtime) {
            let startDate = this.getDate(res?.downtimeStartTime);
            let startTime = this.getStartTime(res?.downtimeStartTime);
            let endDate = this.getDate(res?.downtimeEndTime);
            let endTime = this.getEndTime(res?.downtimeEndTime);
            if (res?.downtimeType?.toLowerCase() === 'maintenance') {
              const message = this.getMaintenanceMessage(startDate, startTime, endTime);
              this.router.navigate(['maintenance']);
              setTimeout(() => {
                this.changeMessage({ type: 'maintenance page', message: message, downtime: true, redirectToLogout: false });
              }, 1000);
            } else if (res?.downtimeType?.toLowerCase() === 'ribbon') {
              const message = this.getRibbonMessage(startDate, startTime, endDate, endTime);
              setTimeout(() => {
                this.changeMessage({ type: 'ribbon', message: message, downtime: true, redirectToLogout: false });
              }, 1000);
            }
          } else {
            this.changeMessage({ type: '', message: '', downtime: false, redirectToLogout: false });
          }
        },
        error: (error) => {
          console.error('Unexpected error in polling:', error);
        }
      });
  }

  stopPolling() {
    if (this.pollingSubscription) {
      this.pollingSubscription?.unsubscribe();
    }
  }


  getMessage(): string {
    return this.message;
  }

  getActiveDowntimeWindow() {
    return this.http.get<any>(this.deploymentApiUrl);
  }

  changeMessage(message: { type: any, message: any, downtime: any, redirectToLogout: boolean }) {
    this.messageSource.next(message);
  }

  getRibbonMessage(startDate, startTime, endDate, endTime) {
    return `<b>All services</b> in the application will be <b>unavailable</b> due to scheduled maintenance from 
          <b>${startDate}</b>, <b>${startTime} to ${endDate}, ${endTime}. </b> Please plan accordingly. Thankyou for your cooperation.`;
  }

  getMaintenanceMessage(startDate, startTime, endTime) {
    return `<b>All services</b> will be <b>unavailable</b> in the application due to scheduled <b>maintenance</b> 
    on <b>${startDate}</b>, from <b>${startTime} to ${endTime}. </b> <br/><br/>
    <b>Please try again later. Thankyou for your cooperation.<b>`
  }

  getDate(date) {
    return this.dateTimeService.formatDateFromUTCTolocalDate(date, 'dd MMMM yyyy');
  }

  getStartTime(startTime) {
    return this.dateTimeService.formatDateFromUTCTolocalDate(startTime, 'HH:mm');
  }

  getEndTime(endTime) {
    return this.dateTimeService.formatDateFromUTCTolocalDate(endTime, 'HH:mm');
  }

}
